import {
  SEND_VALIDATE_ACCOUNT_MAIL_FETCH,
  SEND_VALIDATE_ACCOUNT_MAIL_SUCCESS,
  SEND_VALIDATE_ACCOUNT_MAIL_ERROR,
  SEND_VALIDATE_ACCOUNT_MAIL_RESET,
  VALIDATE_ACCOUNT_FETCH,
  VALIDATE_ACCOUNT_SUCCESS,
  VALIDATE_ACCOUNT_ERROR,
  VALIDATE_ACCOUNT_RESET,
  IS_VALIDATED_FETCH,
  IS_VALIDATED_SUCCESS,
  IS_VALIDATED_ERROR,
  IS_VALIDATED_RESET,
  ValidateAccountState,
  ValidateAccountActions,
  ValidateAccountStatus,
  initialState,
} from './types'

const reducers = (state = initialState, action?: ValidateAccountActions): ValidateAccountState => {
  switch (action?.type) {
    /**
     * Send Validate Account Mail
     */
    case SEND_VALIDATE_ACCOUNT_MAIL_FETCH:
      return {
        ...state,
        mailStatus: ValidateAccountStatus.Loading,
      }
    case SEND_VALIDATE_ACCOUNT_MAIL_SUCCESS:
      return {
        ...state,
        mailStatus: ValidateAccountStatus.Success,
      }
    case SEND_VALIDATE_ACCOUNT_MAIL_ERROR:
      return {
        ...state,
        mailStatus: ValidateAccountStatus.Error,
      }
    case SEND_VALIDATE_ACCOUNT_MAIL_RESET:
      return {
        ...state,
        mailStatus: ValidateAccountStatus.Idle,
      }

    /**
     * Validate Account
     */
    case VALIDATE_ACCOUNT_FETCH:
      return {
        ...state,
        validationStatus: ValidateAccountStatus.Loading,
      }
    case VALIDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        validationStatus: ValidateAccountStatus.Success,
      }
    case VALIDATE_ACCOUNT_ERROR:
      return {
        ...state,
        validationStatus: ValidateAccountStatus.Error,
      }
    case VALIDATE_ACCOUNT_RESET:
      return {
        ...state,
        validationStatus: ValidateAccountStatus.Idle,
      }

    /**
     * Is Validated
     */
    case IS_VALIDATED_FETCH:
      return {
        ...state,
        isValidatedStatus: ValidateAccountStatus.Loading,
      }
    case IS_VALIDATED_SUCCESS:
      return {
        ...state,
        isValidatedStatus: ValidateAccountStatus.Success,
        isValidCompanyAccount: action?.payload,
      }
    case IS_VALIDATED_ERROR:
      return {
        ...state,
        isValidatedStatus: ValidateAccountStatus.Error,
      }
    case IS_VALIDATED_RESET:
      return {
        ...state,
        isValidatedStatus: ValidateAccountStatus.Idle,
        isValidCompanyAccount: null,
      }
    default:
      return state
  }
}

export default reducers
